import { combineReducers } from 'redux';
import EcommerceReducer from './EcommerceReducer';
import NavigationReducer from './NavigationReducer';
import NotificationReducer from './NotificationReducer';
import AuthReducer from './AuthReducer';
import ReviewReducer from './ReviewReducer';
import campaigns from '../../views/campaigns/store';

const RootReducer = combineReducers({
  notifications: NotificationReducer,
  navigations: NavigationReducer,
  ecommerce: EcommerceReducer,
  auth: AuthReducer,
  review: ReviewReducer,
  campaigns
});

export default RootReducer;
